import { z } from "zod";

// Login phone schema
export const loginPhoneSchema = z.object({
  phone: z
    .string()
    .min(10, "Telefon numarası tamamlanmalıdır")
    .max(10, "Telefon numarası geçersiz"),
  countryId: z.number().min(1, "Ülke seçilmelidir"),
});

// Login verification schema
export const loginVerificationSchema = z.object({
  code: z
    .string()
    .length(5, "Doğrulama kodu 5 haneli olmalıdır")
    .regex(/^\d+$/, "Sadece rakam girebilirsiniz"),
});

export type LoginPhoneData = z.infer<typeof loginPhoneSchema>;
export type LoginVerificationData = z.infer<typeof loginVerificationSchema>;

// Legacy schemas - kept for backwards compatibility
export const loginSchema = z.object({
  emailOrPhone: z.string().min(1, "Bu alan zorunludur"),
  password: z.string().min(6, "Şifre en az 6 karakter olmalıdır"),
});

export const otpSchema = z.object({
  code: z
    .string()
    .length(6, "Doğrulama kodu 6 haneli olmalıdır")
    .regex(/^\d+$/, "Sadece rakam girebilirsiniz"),
});

export const emailSchema = z.object({
  email: z.string().email("Geçerli bir e-posta adresi girin"),
});

export const phoneSchema = z.object({
  phone: z
    .string()
    .min(10, "Telefon numarası tamamlanmalıdır")
    .max(10, "Telefon numarası geçersiz"),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type OTPFormData = z.infer<typeof otpSchema>;
export type EmailFormData = z.infer<typeof emailSchema>;
export type PhoneFormData = z.infer<typeof phoneSchema>;